import { createContext, FunctionComponent, useContext, useState } from 'react';
import { OmitMethods } from '../types';

interface ErrorBoundaryContextI {
	isError?: boolean;
	setIsError: (isError: boolean) => void;
}

const initialState: OmitMethods<ErrorBoundaryContextI> = {
	isError: false
};

export const ErrorBoundaryContext = createContext(initialState as ErrorBoundaryContextI);

export const ErrorBoundaryProvider: FunctionComponent = ({ children }) => {
	const [isError, setIsError] = useState<boolean | undefined>(initialState.isError);
	return <ErrorBoundaryContext.Provider value={{ isError, setIsError }}>{children}</ErrorBoundaryContext.Provider>;
};

export function useErrorBoundary() {
	return useContext(ErrorBoundaryContext);
}
